"use strict";

/**
* Закладка боковой панели.
* 
* @class WebAccess.components.wrappers.sideBar.Tab
* @extends BasePageElement
* @property {string} name Имя закладки
* @property {string} selector Путь в DOM-иерархии к объекту группы, например div.content#container
* @property isSynthetic {boolean} Признак, указывающий на то, что закладка была создана средствами API
* @param {string} itemSelector Cуществующий элемент страницы
*/
(function (global) {

  /**
  * Часто используемые селекторы
  */
  var sideBarConatainerSelector = "#card_left_container";
  var tabSelector = "div.tab_item";
  var cardFormTabTemplate = '#CardForm_Tab_{0}';
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
  * Частоиспользуемые jQuery объекты
  */
  var jSideBarConatainer = $(sideBarConatainerSelector);
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

  var Tab = WebAccess.components.wrappers.BasePageElement.extend({
    _current: null,
    dfmName: '',
    helpLink: '',

    init: function (itemSelector, opt_current) {
      this._current = opt_current.current;
      let jTab;

      if (this._current && this._current.sideBar) {
        jTab = this._current.sideBar._jSideBar.find(itemSelector);
      } else {
        jTab = $(itemSelector);
      }

      this._jObject = jTab;
      this._super(jTab);
      this.selector = format(this._byNameSelectorTemplate, tabSelector, this.name);
      this.dfmName = jTab.data('name');
      this.helpLink = jTab.data('help-link') || '';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "Tab",
    isSynthetic: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~// 

    /**
    * Заполнение закладки произвольным контентом
    * 
    * @method WebAccess.current.sideBar.tabs.tab#setHtml
    * @param {string} html - текст html разметки
    * @return {Tab}
    */
    setHtml: function (html) {
      if (global.getLocation() != "explorer") {
        if (this._jObject.hasClass("inline_tab") && !this.isSynthetic) {
          if (this.name == "Card") {
            $("#CardForm_Tab_Card").html(html);
          } else {
            var id = this._jObject.attr("id");
            var num = id.substr(id.length - 1);
            $("#CardForm_Tab_" + num).html(html);
          }
        } else {
          $(format(cardFormTabTemplate, this.name)).html(html);
        };
      } else {
        if (this._current && this._current.className === 'Current') {  //Все исключительные ситуации ниже для совместимости и равнозначности всех закладок.
          switch (this.name) {
            case "FldTree":
              $("#ctl00_LeftContentPlaceHolder_TreeDiv").html(html);
              break;
            default:
              $("#Search").children("#" + this.name).html(html);
          }
        }
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

    click: function (opt_callback) {
      if ($.isFunction(opt_callback)) {
        this.unbind("click");
      };
      this._super(opt_callback);
    },

    /**
    * Скрытие закладки
    *     
    * @method WebAccess.current.sideBar.tabs.tab#setHtml
    * @return {Tab}
    */
    hide: function () {
      this._super();
      if (this._jObject.hasClass("last")) this._jObject.removeClass("last").prev("div").addClass("last");
      return this;
    },

    /**     
    * Показ закладки
    *      
    * @method WebAccess.current.sideBar.tabs.tab#show
    * @return {Tab}
    */
    show: function () {
      this._super();
      if (this._jObject.prev().hasClass("last")) {
        this._jObject.addClass("last").prev("div").removeClass("last");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**     
    * Делает закладку доступной для изменения.
    *      
    * @method WebAccess.current.sideBar.tabs.tab#enable
    * @return {Tab} Объект типа Tab.
    */
    enable: function () {
      var me = this;
      me._super();
      // В карточке ЗЗУ точно не надо ничего байндить. У других объектов - может быть и надо, не проверял.
      const isNotBindedCard = [
        OBJECT_TYPE.EDOCUMENT,
        OBJECT_TYPE.JOB,
        OBJECT_TYPE.TASK,
      ].includes(WA.CR.Type);
      if (!me.isSynthetic && !isNotBindedCard) {
        me._jObject.bind("click", function () {
          me._current.sideBar.tabs._defaultClickHandler(me, me.name, me.selector);
        });
      }
      return me;
    },

    /**     
    * Возвращает признак видимости закладки.
    *      
    * @method WebAccess.current.sideBar.tabs.tab#isVisible
    * @return {boolean} True - закладка отображается, False - закладка скрыта.
    */
    isVisible: function () {
      return this._jObject.is(':visible');
    }

  });

  global.components.wrappers.sideBar.Tab = Tab;
})(window.WebAccess);
